import { useAppSelector } from '../../hooks';
import { isInIframe } from '../utils/isInIframe';
export function useOverlayDisplayLogic() {
  const isOverlayConfigStateInit = useAppSelector(state => state.overlayDisplayConfigState.appOverlayDisplayConfig.isInitialized);
  return {
    isOverlayConfigStateInit,
    isTopLevelWindow: !isInIframe()
  };
}